<template>
  <DBox
    :id="'cmp-settings-task-templates'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_task_template')}`"
    @add_click="onAddTaskTemplateClick"
  >
    <NTable
      class="h2 dbox1"
      :id="'settings-bookings-task_templates'"
      :headers="headers"
      :items="task_templates"
      :config="tableConfig"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr draggable="true" @dragstart="e => onTaskTemplateDragStart(e, item)">
          <td v-bind="tdcon('task_template_name')">
            <span>{{ item.task_template_name }}</span>
          </td>
          <td v-bind="tdcon('day_shift')">
            <span> {{ item.day_shift }} </span>
          </td>
          <td v-bind="tdcon('assigned_user')">
            <span> {{ item.recipients }} </span>
          </td>
          <td v-bind="tdcon('sent_user')">
            <span> {{ item.sender }} </span>
          </td>
          <td v-bind="tdcon('options_edit')">
            <div class="dt-icon-container">
              <img
                src="static/icons/edit-blue.svg"
                class="dt-icon v5 s1"
                @click="e => onEditTaskTemplate(item)"
                :alt="$t('edit_task_template')"
                :title="$t('edit_task_template')"
              />
            </div>
          </td>
          <td v-bind="tdcon('options_delete')">
            <div class="dt-icon-container">
              <img
                v-if="item.is_deletable"
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
                @click="e => onDeleteTaskTemplate(item)"
                :alt="$t('delete_task_template')"
                :title="$t('delete_task_template')"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import { createTableHeader } from "../../../../plugins/datatable";

export default {
  components: {
    NTable,
    DBox
  },
  props: {
    bookingSettingsData: {
      type: Object,
      default: () => []
    }
  },
  data: function() {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        rowHeight: 32,
        fullHeight: true
        // footer: false
      })
    };
  },
  computed: {
    headers: function() {
      return [
        createTableHeader("task_template_name", { f: 2}),
        createTableHeader("day_shift"),
        createTableHeader("assigned_user", { f: 1.2 }),
        createTableHeader("sent_user", { f: 1.2 }),
        createTableHeader("options_edit", { mw: 35, text: false }),
        createTableHeader("options_delete", { mw: 35, text: false })
      ];
    },
    task_templates: function() {
      return this.bookingSettingsData?.task_templates || [];
    }
  },
  methods: {
    onAddTaskTemplateClick: function() {
      this.$emit("add_click", true);
    },
    onDeleteTaskTemplate: function({ task_template_id }) {
      this.$emit("delete", task_template_id);
    },
    onEditTaskTemplate: function({ task_template_id }) {
      openModalRoute(this, "task_template_form", {
        task_template_id,
        mode: "edit"
      });
    },
    onTaskTemplateDragStart: function(event, item) {
      if (!item) {
        return;
      }
      event.dataTransfer.setData("text", JSON.stringify(item));
    }
    // MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-settings-task-templates {
  .dt-ntable {
    td.options {
      display: flex;
      flex-direction: row;
    }
  }
}
</style>
